"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrderFailure = exports.fetchOrderSuccess = exports.fetchOrderRequest = exports.step4SetAdditional = exports.step4Toggle = exports.step3Browse = exports.step3RemoveFile = exports.step3ChangeColor = exports.proceedWithoutInvalidFiles = exports.prevalidateImportedFilesFailed = exports.prevalidateImportedFilesSuccess = exports.prevalidateImportedFilesRequest = exports.prevalidateFilesFailed = exports.prevalidateFilesSuccess = exports.prevalidateFilesRequest = exports.createNewOrderFailed = exports.createNewOrderSuccess = exports.createNewOrderRequest = exports.valuesChangeDistributionRecipientPrintProvider = exports.valuesChangeDistributionRecipientDeliveryMethod = exports.valuesChangeDistributionRecipientFinishing = exports.valuesChangeDistributionRecipientQuantity = exports.valuesSetRequestTimeOfDelivery = exports.setBillingInformationProject = exports.valuesSetBillingInformation = exports.valuesUpdateCustomBillingInformationField = exports.valuesRemoveDistributionRecipient = exports.valuesAddOrderRecipients = exports.valuesRemoveDistributionLists = exports.valuesAddDistributionLists = exports.valuesSetName = exports.step3RestoreFile = exports.step3UnselectFiles = exports.step3SelectFiles = exports.step2AddRecipientTab = exports.step2AddRecipientAddNewDeliveryAddress = exports.step2AddRecipientUnselect = exports.step2AddRecipientSelect = exports.excludeRecipient = exports.step2AddDistributionListUnselect = exports.step2AddDistributionListSelect = exports.step2ListUnselectRecipients = exports.step2ListSelectRecipients = exports.step2ListUnselectDistributionList = exports.step2ListSelectDistributionList = exports.step2ChangeDisplay = exports.validateStepSuccess = exports.validateStepFailure = exports.changeStep = exports.clearWizard = void 0;
exports.fetchRecipientsFailure = exports.fetchRecipientsSuccess = exports.fetchRecipients = exports.deleteOrderFailure = exports.deleteOrderSuccess = exports.deleteOrder = exports.fetchOrderFilesFailure = exports.fetchOrderFilesSuccess = exports.fetchOrderFilesRequest = void 0;
const ActionTypes = require("../../actionTypes/order/wizard");
const actions_1 = require("../../modules/orderFiles/actions");
const orderFiles = (0, actions_1.default)('order');
const clearWizard = () => ({
    type: ActionTypes.CLEAR_WIZARD
});
exports.clearWizard = clearWizard;
const changeStep = (wizardStep, mode, type) => ({
    type: ActionTypes.CHANGE_STEP,
    payload: {
        wizardStep,
        mode,
        type
    }
});
exports.changeStep = changeStep;
const validateStepFailure = (errors) => ({
    type: ActionTypes.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = (wizardStep) => ({
    type: ActionTypes.VALIDATE_STEP_SUCCESS,
    payload: {
        wizardStep
    }
});
exports.validateStepSuccess = validateStepSuccess;
//#region STEP 2
const step2ChangeDisplay = (display) => ({
    type: ActionTypes.STEP2_CHANGE_DISPLAY,
    payload: {
        display
    }
});
exports.step2ChangeDisplay = step2ChangeDisplay;
// LIST
const step2ListSelectDistributionList = (selected) => ({
    type: ActionTypes.STEP2_LIST_SELECT_DISTRIBUTION_LIST,
    payload: {
        selected
    }
});
exports.step2ListSelectDistributionList = step2ListSelectDistributionList;
const step2ListUnselectDistributionList = (unselected) => ({
    type: ActionTypes.STEP2_LIST_UNSELECT_DISTRIBUTION_LIST,
    payload: {
        unselected
    }
});
exports.step2ListUnselectDistributionList = step2ListUnselectDistributionList;
const step2ListSelectRecipients = (selected) => ({
    type: ActionTypes.STEP2_LIST_SELECT_RECIPIENTS,
    payload: {
        selected
    }
});
exports.step2ListSelectRecipients = step2ListSelectRecipients;
const step2ListUnselectRecipients = (unselected) => ({
    type: ActionTypes.STEP2_LIST_UNSELECT_RECIPIENTS,
    payload: {
        unselected
    }
});
exports.step2ListUnselectRecipients = step2ListUnselectRecipients;
// ADD_DISTRIBUTION_LIST
const step2AddDistributionListSelect = (selected) => ({
    type: ActionTypes.STEP2_ADD_DISTRIBUTION_LIST_SELECT,
    payload: {
        selected
    }
});
exports.step2AddDistributionListSelect = step2AddDistributionListSelect;
const step2AddDistributionListUnselect = (unselected) => ({
    type: ActionTypes.STEP2_ADD_DISTRIBUTION_LIST_UNSELECT,
    payload: {
        unselected
    }
});
exports.step2AddDistributionListUnselect = step2AddDistributionListUnselect;
const excludeRecipient = (id) => ({
    type: ActionTypes.EXCLUDE_RECIPIENT,
    payload: {
        id
    }
});
exports.excludeRecipient = excludeRecipient;
// ADD_RECIPIENT
const step2AddRecipientSelect = (selected) => ({
    type: ActionTypes.STEP2_ADD_RECIPIENT_SELECT,
    payload: {
        selected
    }
});
exports.step2AddRecipientSelect = step2AddRecipientSelect;
const step2AddRecipientUnselect = (unselected) => ({
    type: ActionTypes.STEP2_ADD_RECIPIENT_UNSELECT,
    payload: {
        unselected
    }
});
exports.step2AddRecipientUnselect = step2AddRecipientUnselect;
const step2AddRecipientAddNewDeliveryAddress = (addNewDeliveryAddress) => ({
    type: ActionTypes.STEP2_ADD_RECIPIENT_ADD_NEW_DELIVERY_ADDRESS,
    payload: {
        addNewDeliveryAddress
    }
});
exports.step2AddRecipientAddNewDeliveryAddress = step2AddRecipientAddNewDeliveryAddress;
const step2AddRecipientTab = (tab) => ({
    type: ActionTypes.STEP2_ADD_RECIPIENT_TAB,
    payload: {
        tab
    }
});
exports.step2AddRecipientTab = step2AddRecipientTab;
//#endregion
exports.step3SelectFiles = orderFiles.selectFiles;
exports.step3UnselectFiles = orderFiles.unselectFiles;
exports.step3RestoreFile = orderFiles.restoreFile;
const valuesSetName = (name) => ({
    type: ActionTypes.VALUES_SET_NAME,
    payload: {
        name
    }
});
exports.valuesSetName = valuesSetName;
const valuesAddDistributionLists = (distributionLists) => ({
    type: ActionTypes.VALUES_ADD_DISTRIBUTION_LISTS,
    payload: {
        distributionLists
    }
});
exports.valuesAddDistributionLists = valuesAddDistributionLists;
const valuesRemoveDistributionLists = (distributionLists) => ({
    type: ActionTypes.VALUES_REMOVE_DISTRIBUTION_LISTS,
    payload: {
        distributionLists
    }
});
exports.valuesRemoveDistributionLists = valuesRemoveDistributionLists;
const valuesAddOrderRecipients = (orderRecipients) => ({
    type: ActionTypes.VALUES_ADD_DISTRIBUTION_RECIPIENTS,
    payload: {
        orderRecipients
    }
});
exports.valuesAddOrderRecipients = valuesAddOrderRecipients;
const valuesRemoveDistributionRecipient = (uuid) => ({
    type: ActionTypes.VALUES_REMOVE_DISTRIBUTION_RECIPIENT,
    payload: {
        uuid
    }
});
exports.valuesRemoveDistributionRecipient = valuesRemoveDistributionRecipient;
const valuesUpdateCustomBillingInformationField = (key, value) => ({
    type: ActionTypes.VALUES_UPDATE_CUSTOM_BILLING_INFORMATION_FIELD,
    payload: {
        key,
        value
    }
});
exports.valuesUpdateCustomBillingInformationField = valuesUpdateCustomBillingInformationField;
const valuesSetBillingInformation = (value) => ({
    type: ActionTypes.VALUES_SET_BILLING_INFORMATION,
    payload: value
});
exports.valuesSetBillingInformation = valuesSetBillingInformation;
const setBillingInformationProject = (project) => ({
    type: ActionTypes.SET_BILLING_INFORMATION_PROJECT,
    payload: {
        project
    }
});
exports.setBillingInformationProject = setBillingInformationProject;
const valuesSetRequestTimeOfDelivery = (value) => ({
    type: ActionTypes.VALUES_SET_REQUEST_TIME_OF_DELIVERY,
    payload: {
        value
    }
});
exports.valuesSetRequestTimeOfDelivery = valuesSetRequestTimeOfDelivery;
const valuesChangeDistributionRecipientQuantity = (uuid, value) => ({
    type: ActionTypes.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_QUANTITY,
    payload: {
        uuid,
        value
    }
});
exports.valuesChangeDistributionRecipientQuantity = valuesChangeDistributionRecipientQuantity;
const valuesChangeDistributionRecipientFinishing = (uuid, value) => ({
    type: ActionTypes.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_FINISHING,
    payload: {
        uuid,
        value
    }
});
exports.valuesChangeDistributionRecipientFinishing = valuesChangeDistributionRecipientFinishing;
const valuesChangeDistributionRecipientDeliveryMethod = (uuid, value) => ({
    type: ActionTypes.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_DELIVERY_METHOD,
    payload: {
        uuid,
        value
    }
});
exports.valuesChangeDistributionRecipientDeliveryMethod = valuesChangeDistributionRecipientDeliveryMethod;
const valuesChangeDistributionRecipientPrintProvider = (uuid, value) => ({
    type: ActionTypes.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_PRINT_PROVIDER,
    payload: {
        uuid,
        value
    }
});
exports.valuesChangeDistributionRecipientPrintProvider = valuesChangeDistributionRecipientPrintProvider;
const createNewOrderRequest = (type, folderId) => ({
    type: ActionTypes.CREATE_NEW_ORDER_REQUEST,
    payload: Object.assign(Object.assign({}, type), { folderId })
});
exports.createNewOrderRequest = createNewOrderRequest;
const createNewOrderSuccess = (order) => ({
    type: ActionTypes.CREATE_NEW_ORDER_SUCCESS,
    payload: order
});
exports.createNewOrderSuccess = createNewOrderSuccess;
const createNewOrderFailed = (e) => ({
    type: ActionTypes.CREATE_NEW_ORDER_FAILED,
    payload: e
});
exports.createNewOrderFailed = createNewOrderFailed;
exports.prevalidateFilesRequest = orderFiles.prevalidateFilesRequest;
exports.prevalidateFilesSuccess = orderFiles.prevalidateFilesSuccess;
exports.prevalidateFilesFailed = orderFiles.prevalidateFilesFailure;
exports.prevalidateImportedFilesRequest = orderFiles.prevalidateImportedFilesRequest;
exports.prevalidateImportedFilesSuccess = orderFiles.prevalidateImportedFilesSuccess;
exports.prevalidateImportedFilesFailed = orderFiles.prevalidateImportedFilesFailure;
const proceedWithoutInvalidFiles = () => ({
    type: ActionTypes.PROCEED_WITHOUT_INVALID_FILES
});
exports.proceedWithoutInvalidFiles = proceedWithoutInvalidFiles;
exports.step3ChangeColor = orderFiles.changeColor;
exports.step3RemoveFile = orderFiles.removeFile;
exports.step3Browse = orderFiles.browse;
const step4Toggle = () => ({
    type: ActionTypes.STEP4_TOGGLE
});
exports.step4Toggle = step4Toggle;
const step4SetAdditional = (text) => ({
    type: ActionTypes.STEP4_SET_ADDITIONAL,
    payload: {
        text: text
    }
});
exports.step4SetAdditional = step4SetAdditional;
const fetchOrderRequest = (id, mode, type) => ({
    type: ActionTypes.FETCH_ORDER_REQUEST,
    payload: {
        id: id,
        mode: mode,
        type: type
    }
});
exports.fetchOrderRequest = fetchOrderRequest;
const fetchOrderSuccess = (data) => ({
    type: ActionTypes.FETCH_ORDER_SUCCESS,
    payload: data
});
exports.fetchOrderSuccess = fetchOrderSuccess;
const fetchOrderFailure = (error) => ({
    type: ActionTypes.FETCH_ORDER_FAILURE,
    payload: error
});
exports.fetchOrderFailure = fetchOrderFailure;
const fetchOrderFilesRequest = (id, mode) => ({
    type: ActionTypes.FETCH_ORDER_FILES_REQUEST,
    payload: {
        id,
        mode
    }
});
exports.fetchOrderFilesRequest = fetchOrderFilesRequest;
const fetchOrderFilesSuccess = (data) => ({
    type: ActionTypes.FETCH_ORDER_FILES_SUCCESS,
    data
});
exports.fetchOrderFilesSuccess = fetchOrderFilesSuccess;
const fetchOrderFilesFailure = (error) => ({
    type: ActionTypes.FETCH_ORDER_FILES_FAILURE,
    payload: error
});
exports.fetchOrderFilesFailure = fetchOrderFilesFailure;
const deleteOrder = (id, project) => ({
    type: ActionTypes.DELETE_ORDER,
    payload: {
        id,
        project
    }
});
exports.deleteOrder = deleteOrder;
const deleteOrderSuccess = (orders) => ({
    type: ActionTypes.DELETE_ORDER_SUCCESS,
    payload: orders
});
exports.deleteOrderSuccess = deleteOrderSuccess;
const deleteOrderFailure = (error) => ({
    type: ActionTypes.DELETE_ORDER_FAILURE,
    payload: error
});
exports.deleteOrderFailure = deleteOrderFailure;
const fetchRecipients = (id, mode) => ({
    type: ActionTypes.FETCH_RECIPIENTS,
    payload: {
        id,
        mode
    }
});
exports.fetchRecipients = fetchRecipients;
const fetchRecipientsSuccess = (recipients) => ({
    type: ActionTypes.FETCH_RECIPIENTS_SUCCESS,
    recipients: recipients
});
exports.fetchRecipientsSuccess = fetchRecipientsSuccess;
const fetchRecipientsFailure = (error) => ({
    type: ActionTypes.FETCH_RECIPIENTS_FAILURE,
    payload: error
});
exports.fetchRecipientsFailure = fetchRecipientsFailure;
//# sourceMappingURL=wizard.js.map